<template>
  <ul v-if="navlist.length>0">
    <li 
      :data-t="item.include"
      v-for="(item,index) in navlist"  
      :class="{'active':path ==item.path || path.indexOf(item.path)>=0 || path.indexOf(item.include)>=0,'special':item.special}">
      <p @click="goPage(item)">
        <span class="speical-icon" :class="item.icon" v-if="item.special"></span>
        <span class="name">{{item.name}}</span>
        <!-- <router-link :to="item.path">{{item.name}}</router-link> -->
        <span class="flag" v-if="item.flag">{{ item.flag }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
import colums from '../colums/colums.js'
export default {
  name: 'topnav',
  props: {
    
  },
  data(){
    return{
      navlist:colums.navlist
    }
  },
  computed:{
    path(){
      if(this.$route.fullPath.indexOf("/book/")>=0){
        return "/literature"
      }
      return this.$route.fullPath;
    }
  },
  methods: {
    goPage(item){
      this.$router.push(item.path)
    }
  },
}
</script>